<dialog
  #dialog
  qai-dialog
  [description]="dialogDescription"
  [heading]="modalHeading"
  (afterClose)="handleCloseClick()"
>
  <div class="filters-row">
    <qai-field class="tags-field" [label]="'simulationBuilder.TAGS_FILTER_LABEL' | transloco">
      <qai-searchable-select
        [shape]="'rectangle'"
        [options]="tagOptions"
        [value]="selectedTags"
        [multiselect]="true"
        [searchable]="true"
        [disabled]="tagOptions.length === 0"
        [placeholder]="'simulationBuilder.TAGS_FILTER_PLACEHOLDER' | transloco"
        (valueChange)="onTagsChange($event)"
      ></qai-searchable-select>
    </qai-field>

    <qai-field class="search-field" [label]="fieldLabel">
      <qai-tree-select
        *ngIf="allTeamsWithUsers.length === 0"
        [treeData]="[]"
      ></qai-tree-select>

      <qai-tree-select
        *ngIf="allTeamsWithUsers.length !== 0"
        [treeData]="allTeamsWithUsers"
        [tagFilter]="selectedTags"
        (selectionsSave)="onSelectionSave($event)"
        (searchTermChange)="onSearchTermChange($event)"
        [showIndividualBadge]="false"
        maxHeight="30dvh"
      ></qai-tree-select>

      <span qaiSlot="endIcon">
        @if (isLoadingUsers) {
          <qai-spinner size="xsmall"></qai-spinner>
        }
      </span>

      <span qaiSlot="label" *ngIf="selectedUsers.length > 0">
        <button qai-link class="remove-all-button" (click)="onRemoveAll()">
          {{ 'simulationBuilder.BUTTON_REMOVE_ALL' | transloco }}
        </button>
      </span>
    </qai-field>
  </div>

  @if (hasActiveFilters) {
    <div class="clear-filters-container">
      <button qai-link class="clear-filters-button" (click)="clearAllFilters()">
        {{ 'simulationBuilder.CLEAR_ALL_FILTERS' | transloco }}
      </button>
    </div>
  }

  <div class="action-button-container">
    <button
      qai-button
      kind="secondary"
      [size]="'medium'"
      (click)="handleCloseClick()"
    >
      {{ isCreateAssignmentFlow ? ('simulationBuilder.BUTTON_BACK' | transloco) : ('simulationBuilder.BUTTON_CANCEL' | transloco) }}
    </button>
    <button
      qai-button
      size="medium"
      kind="primary"
      [disabled]="selectedUsers.length === 0"
      (click)="openReviewModal()"
    >
      {{ 'simulationBuilder.BUTTON_REVIEW_SELECTED_USERS' | transloco }}
    </button>
  </div>
</dialog>

<assignment-users-confirmation-modal
  [open]="showReviewModal"
  [isCreateAssignmentFlow]="isCreateAssignmentFlow"
  [selectedUsers]="selectedUsersWithDetails"
  [networkRequestInProgress]="networkRequestInProgress"
  (closeModal)="showReviewModal = false"
  (cancelClicked)="onCancelFromConfirmation()"
  (confirmClicked)="handleSuccessClick()"
  (userRemoved)="onUserRemovedFromReview($event)"
></assignment-users-confirmation-modal>
